import { Dialog, DialogContent, DialogTitle, IconButton, TextField } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';
import "./IlanReklamTarifeleriPopUp.css"
import { Form, Formik } from "formik";
/*
props.openPopup() popup kapatma fonksiyonu
props.data popupa gelen veri*/


const IlanReklamVergisiTarifeleriPopup = (props: any) => {
    //Formik constantları
    const initialValues = {
        //boş kalacak ihtiyaca göre kullanılabilir
    };
    return (
        <Dialog
            sx={{
                '& .MuiDialog-paper': {
                    m: "0.5rem", // margin değerini sıfırla
                    maxWidth: '100%', // Maksimum genişliği %100 yap, ekranı tam kaplasın
                    width: '100%', // Genişliği %100 yap
                    maxHeight: '100vh', // Maksimum yüksekliği viewport'un %100'ü yap
                }
            }}
            fullWidth={true}
            maxWidth="xl"

            open={props.openPopup}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
        >
            <DialogTitle justifyContent={"space-between"} marginLeft={"4%"} id="dialog-title">{"İlan Reklam Tarife Bilgileri"}
                <IconButton
                    aria-label="close"
                    onClick={() => props.openPopup()}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme: any) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton> </DialogTitle>
            <Formik
                initialValues={initialValues}
                onSubmit={() => { }}>
                <Form><div className="p-5">
                    <div className="d-flex flex-column  p-2 mt-3 gap-4 w-100">
                        <div className="d-flex flex-column flex-sm-row w-100 form-group ">
                            <label className="w-25">Yılı</label>
                            <TextField size="small" className="w-100" value={props.data[0].yili} />
                        </div>
                        <div className=" d-flex flex-column flex-sm-row w-100 form-group ">
                            <label className="gelirAciklamaLabel">Gelir Açıklaması</label>
                            <TextField size="small" maxRows={3} className="w-100" value={props.data[0].gelirAciklamasi} />
                        </div>
                    </div>
                    <div className="mt-4">
                        <div className="d-flex flex-column flex-sm-row p-2 mt-2">
                            <label className="tarifeLabel">Tarife M2 1/ Tutarı</label>
                            <div className="d-flex w-100 flex-column flex-sm-row tarifeGap">
                                <TextField size="small" className="w-100" value={props.data[0].tarifeM21} />
                                <TextField size="small" className="w-100" value={props.data[0].tutari1} />
                            </div>

                        </div>
                        <div className="d-flex flex-column flex-sm-row p-2 mt-2">
                            <label className="tarifeLabel">Tarife M2 2/ Tutarı</label>
                            <div className="d-flex w-100 flex-column flex-sm-row tarifeGap">
                                <TextField size="small" className="w-100" value={props.data[0].tarifeM22} />
                                <TextField size="small" className="w-100" value={props.data[0].tutari2} />
                            </div>

                        </div>
                        <div className="d-flex flex-column flex-sm-row p-2 mt-2">
                            <label className="tarifeLabel">Tarife M2 3/ Tutarı</label>
                            <div className="d-flex w-100 flex-column flex-sm-row tarifeGap">
                                <TextField size="small" className="w-100" value={props.data[0].tarifeM23} />
                                <TextField size="small" className="w-100" value={props.data[0].tutari3} />
                            </div>

                        </div>
                        <div className="d-flex flex-column flex-sm-row p-2 mt-2">
                            <label className="tarifeLabel">Tarife M2 4/ Tutarı</label>
                            <div className="d-flex w-100 flex-column flex-sm-row tarifeGap">
                                <TextField size="small" className="w-100" value={props.data[0].tarifeM24} />
                                <TextField size="small" className="w-100" value={props.data[0].tutari4} />
                            </div>

                        </div>
                        <div className="d-flex flex-column flex-sm-row p-2 mt-2">
                            <label className="tarifeLabel">Tarife M2 5/ Tutarı</label>
                            <div className="d-flex w-100 flex-column flex-sm-row tarifeGap">
                                <TextField size="small" className="w-100" value={props.data[0].tarifeM25} />
                                <TextField size="small" className="w-100" value={props.data[0].tutari5} />
                            </div>
                        </div>
                    </div>
                </div>
                </Form>
            </Formik>



        </Dialog>
    )

}




export default IlanReklamVergisiTarifeleriPopup
